/**
 * Planhat tracks customer health. Internal and non-genuine sessions must never
 * reach it (they would pollute customer activity streams and health scores).
 */
export type TrackingSuppressionContext = {
    isSupport: boolean;
    isConsultant: boolean;
    isSimulating: boolean;
    email: string | null | undefined;
};

/** Email domains used by Sysarb staff accounts. */
const INTERNAL_EMAIL_DOMAINS = ['sysarb.se', 'sysarb.com'] as const;

/**
 * Sysarb staff are identified by email domain. Matches the domain suffix
 * after '@' only, so an address that merely contains a staff domain in its
 * local part (e.g. sysarb.se@customer.com) is not misclassified.
 */
export function isInternalUser(email: string | null | undefined): boolean {
    if (email == null) return false;
    const normalized = email.trim().toLowerCase();
    return INTERNAL_EMAIL_DOMAINS.some(domain => normalized.endsWith(`@${domain}`));
}

export function shouldSuppressTracking(ctx: TrackingSuppressionContext): boolean {
    if (ctx.isSupport) return true;
    if (ctx.isConsultant) return true;
    if (ctx.isSimulating) return true;
    if (isInternalUser(ctx.email)) return true;
    return false;
}
